import React from 'react'
import city from '../../../assets/images/city.png'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';

export default function FourthSection() {
    const place = useSelector(state => state.place);
    const localSelectedCity = localStorage.getItem('selectedCity');
    return (

        <section className="section-equal-padding favorite-section uk-scrollspy-inview"
            style={{ backgroundImage: `url(${city})` }}
            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
            <div className="container-fluid">
                <div className="favorite-block discover_atlanta_text uk-scrollspy-inview"
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                    <h2 className="mb-4">Discover Atlanta</h2>
                    <p>Rich History: Explore Atlanta's rich history through landmarks like the Martin Luther King Jr.
                        National Historic Site and the Atlanta History Center.
                        Cultural Delights: Immerse yourself in Atlanta's vibrant arts scene, from the High Museum of Art to
                        the Fox Theatre's Broadway shows.
                        Culinary Adventures: Delight in Atlanta's diverse food scene, from Southern comfort food and
                        barbecue to innovative culinary experiences.
                        Natural Wonders: Enjoy the beautiful landscapes of Piedmont Park and the Atlanta Botanical Garden,
                        offering a peaceful retreat in the city.
                        Local Hospitality: Experience the warmth and friendliness of Atlanta's residents as you explore the
                        city's neighborhoods and attractions. Safety and Comfort: Navigate through Atlanta with confidence,
                        enjoying a blend of Southern charm and modern amenities in a secure environment.</p>
                    <Link to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/deals/${place}` : `/deals`} className="white-btn mt-3">View Deals</Link>
                </div>
            </div>
        </section>
    )
}
